import { useState } from "react";
import { XMarkIcon } from '@heroicons/react/20/solid'
import { useAuth } from "../../util/auth";
import { useLocation } from "../../util/router";

const REGISTRATION_URL = "https://events.zoom.us/ev/Av9gTeruflzyzt9Y6pxedKszdlKWnnlhCCdstAih7dBjnkyQ684u~Att_siRftqozydHUmCJ9ibyhHYfd87bGo8buB1vDrX9HkU_-eaYmAiF7Nw";

const DAY_FMT = new Intl.DateTimeFormat('en-US', { weekday: 'long', timeZone: 'America/Denver' });
const HOUR_FMT = new Intl.DateTimeFormat('en-US', { hour: 'numeric', hour12: false, timeZone: 'America/Denver' });

function isWednesdayMorningMT() {
  const now = new Date();
  const dayOfWeek = DAY_FMT.format(now);
  const hour = parseInt(HOUR_FMT.format(now), 10);
  return dayOfWeek === "Wednesday" && hour < 11;
}

const INTERNAL_PREFIXES = ["/dashboard", "/admin", "/tools", "/teams", "/settings", "/help", "/calendar"];

export default function LiveViewSection() {
  const [dismissed, setDismissed] = useState(false);
  const auth = useAuth();
  const location = useLocation();

  const isInternalPage = INTERNAL_PREFIXES.some(prefix => location.pathname.startsWith(prefix));

  if (!auth.user || !isInternalPage || dismissed || !isWednesdayMorningMT()) return null;

  return (
    <div className="container">
      <div className="bg-green-50 py-4 px-6 sm:px-12 rounded-lg mb-3">
        <div className="flex items-start">
          <div className="flex-1">
            <p className="text-2xl font-medium text-green-700">
              We are Live Today!
            </p>
          </div>
          <button
            type="button"
            onClick={() => setDismissed(true)}
            className="inline-flex rounded-md bg-green-50 p-1.5 text-green-500 hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-green-600 focus:ring-offset-2 focus:ring-offset-green-50"
          >
            <span className="sr-only">Dismiss</span>
            <XMarkIcon aria-hidden="true" className="h-5 w-5" />
          </button>
        </div>
        <p className="text-md font-medium text-gray-600 mt-1">
          Live Training — Wednesdays at 10:00 AM Mountain Time
        </p>
        <a href={REGISTRATION_URL} target="_blank" rel="noopener noreferrer" className="inline-block bg-green-600 text-white m-2 p-2 rounded-lg">
          Join Live Training
        </a>
      </div>
    </div>
  );
}
